import * as _ from 'lodash';

export default class Formatting {
  static value(value): any {
    if (_.isString(value)) {
      value = value.replaceAll('<', '&lt');
      value = value.replaceAll('>', '&gt');
    }

    return value;
  }
}
